export const PHONE_NUMBER_PATTERN = '^(\\+[0-9]+)?(?:[0-9\\-\\/ ]*\\([0-9]+\\))*[0-9\\-\\/ ]+$';
